module.exports = __webpack_public_path__ + "img/ppsl.27b6c8ed.png";